<template>
  <div>
    <b-row class="shadow-sm" no-gutters>
      <b-col cols="12" class="bg-gradient-primary p-3 pt-1">
        <div class="container">
          <h2 class="text-left text-white mt-2 text-uppercase">
            {{ $t('change_password') }}
          </h2>
        </div>
      </b-col>
    </b-row>
    <b-container>
      <b-row align-h="center" class="pt-5">
        <div>
          <b-card no-body class="overflow-hidden" style="max-width: 1000px">
            <b-row no-gutters>
              <b-col cols="12" md="7">
                <div>
                  <b-card-img-lazy
                    blank-color="#f1f1f1"
                    fluid-grow
                    img-left
                    :src="require('../assets/images/cover-login.png') || ''"
                    alt="Image"
                    class="rounded-0"
                    style="min-width: 300px; height: auto"
                  ></b-card-img-lazy>
                </div>
              </b-col>
              <b-col cols="12" md="5">
                <b-card-body :title="'Password Change Required'">
                  <b-form @submit.stop.prevent="onSubmit">
                    <p class="text-left text-danger">{{ responseMessage }}</p>
                    <!-- --- input --- -->
                    <b-form-group
                      id="login-password-group"
                      label-for="login-password"
                    >
                      <b-form-input
                        id="login-password"
                        v-model="$v.form.oldPassword.$model"
                        type="password"
                        :placeholder="$t('old_password')"
                        aria-describedby="login-password-live-feedback"
                        class="mt-5"
                        :state="validateState('oldPassword')"
                      ></b-form-input>
                      <!-- :state="combinedPasswordState" -->
                      <b-form-invalid-feedback
                        id="login-password-live-feedback"
                      >
                        <!-- <span class="error" v-if="passwordErrors.length">
                          <div v-for="(err, i) in passwordErrors" :key="i">
                            {{ err }}
                          </div>
                        </span> -->
                        <!-- <div v-if="!$v.form.password.minLength">
                          Must have at least
                          {{ $v.form.password.$params.minLength.min }}
                          letters.
                        </div> -->
                        <span
                          class="error"
                          v-if="!$v.form.oldPassword.required"
                        >
                          Must not be empty.
                        </span>
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                      id="new-password-group"
                      label-for="new-password"
                    >
                      <b-form-input
                        id="new-password"
                        v-model="$v.form.newPassword.$model"
                        type="password"
                        :placeholder="$t('new_password')"
                        aria-describedby="new-password-live-feedback"
                        :state="ncombinedPasswordState"
                        class="mt-5"
                      ></b-form-input>
                      <b-form-invalid-feedback id="new-password-live-feedback">
                        <span class="error" v-if="npasswordErrors.length">
                          <div v-for="(err, i) in npasswordErrors" :key="i">
                            {{ err }}
                          </div>
                        </span>
                        <div v-else-if="!$v.form.newPassword.minLength">
                          Must have at least
                          {{ $v.form.newPassword.$params.minLength.min }}
                          letters.
                        </div>
                        <span
                          class="error"
                          v-else-if="!$v.form.newPassword.required"
                        >
                          Must not be empty.
                        </span>
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <b-form-group
                      id="confirm-password-group"
                      label-for="confirm-password"
                    >
                      <b-form-input
                        id="confirm-password"
                        v-model="$v.form.confirmPassword.$model"
                        type="password"
                        :placeholder="$t('confirm_password')"
                        aria-describedby="confirm-password-live-feedback"
                         :state="ccombinedPasswordState"
                        class="mt-5"
                      ></b-form-input>
                      <b-form-invalid-feedback
                        id="confirm-password-live-feedback"
                      >
                      <span class="error" v-if="cpasswordErrors.length">
                          <div v-for="(err, i) in cpasswordErrors" :key="i">
                            {{ err }}
                          </div>
                        </span>
                        <span
                          class="error"
                          v-else-if="!$v.form.confirmPassword.minLength"
                        >
                          Must have at least
                          {{ $v.form.confirmPassword.$params.minLength.min }}
                          letters.
                        </span>
                        <span
                          class="error"
                          v-else-if="!$v.form.confirmPassword.required"
                        >
                          Must not be empty.
                        </span>
                        <span
                          class="error"
                          v-else-if="!$v.form.confirmPassword.sameAs"
                        >
                          Must be same with new password.
                        </span>
                        <span
                          class="error"
                          v-else-if="$v.form.confirmPassword.$error"
                        >
                          Invalid.
                        </span>
                      </b-form-invalid-feedback>
                    </b-form-group>
                    <!-- --- end of input --- -->

                    <b-button
                      block
                      variant="primary"
                      class="mt-5"
                      type="submit"
                      :disabled="loading"
                    >
                      {{ $t('change_password') }}
                    </b-button>
                  </b-form>
                </b-card-body>
              </b-col>
            </b-row>
          </b-card>
        </div>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';
import {
  BCard,
  BCardImgLazy,
  BCardBody,
  BForm,
  BFormInput,
  BButton,
  BFormGroup,
  BFormInvalidFeedback,
} from 'bootstrap-vue';
import { checkRules } from '../helpers/validation-rules';
import authService from '../services/auth.service';
export default {
  components: {
    BCard,
    BCardImgLazy,
    BCardBody,
    BForm,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInvalidFeedback,
  },
  mixins: [validationMixin],
  data: () => ({
    loading: false,
    responseMessage: '',
    loggedInUser: {},
    form: {
      oldPassword: null,
      newPassword: null,
      confirmPassword: null,
    },
  }),
  metaInfo() {
    return {
      title: 'Change Password',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'Please login to buy and online shopping',
        },
      ],
    };
  },
  validations: {
    form: {
      oldPassword: {
        required,
        minLength: minLength(8),
      },
      newPassword: {
        required,
        minLength: minLength(15),
      },
      confirmPassword: {
        required,
        minLength: minLength(15),
        sameAs: sameAs('newPassword'),
      },
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    passwordRules() {
      return checkRules(this.form.username).password;
    },
    passwordErrors() {
      return this.passwordRules
        .map((rule) => {
          if (typeof rule !== 'function') return true;
          return rule(this.form.oldPassword);
        })
        .filter((result) => result !== true);
    },
    passwordState() {
      if (!this.form.password) return null;
      const requiredValid = this.$v.form.oldPassword.required;
      const rulesValid = this.passwordErrors.length === 0;
      if (!requiredValid || !rulesValid) return false;
      return true;
    },
    combinedPasswordState() {
      const vuelidateState = this.validateState('oldPassword');
      const customState = this.passwordState;
      if (vuelidateState === false || customState === false) return false;
      if (vuelidateState === true && customState === true) return true;
      return null;
    },

    npasswordErrors() {
      return this.passwordRules
        .map((rule) => {
          if (typeof rule !== 'function') return true;
          return rule(this.form.newPassword);
        })
        .filter((result) => result !== true);
    },
    npasswordState() {
      if (!this.form.newPassword) return null;
      const requiredValid = this.$v.form.newPassword.required;
      const rulesValid = this.npasswordErrors.length === 0;
      if (!requiredValid || !rulesValid) return false;
      return true;
    },
    ncombinedPasswordState() {
      const vuelidateState = this.validateState('newPassword');
      const customState = this.npasswordState;
      if (vuelidateState === false || customState === false) return false;
      if (vuelidateState === true && customState === true) return true;
      return null;
    },

    cpasswordErrors() {
      return this.passwordRules
        .map((rule) => {
          if (typeof rule !== 'function') return true;
          return rule(this.form.confirmPassword);
        })
        .filter((result) => result !== true);
    },
    cpasswordState() {
      if (!this.form.confirmPassword) return null;
      const requiredValid = this.$v.form.confirmPassword.required;
      const rulesValid = this.cpasswordErrors.length === 0;
      if (!requiredValid || !rulesValid) return false;
      return true;
    },
    ccombinedPasswordState() {
      const vuelidateState = this.validateState('confirmPassword');
      const customState = this.cpasswordState;
      if (vuelidateState === false || customState === false) return false;
      if (vuelidateState === true && customState === true) return true;
      return null;
    },

  },
  created() {
    if (this.$store.state.auth.status.loggedIn && !this.mustChangePassword()) {
      this.$router.push('/');
    }
  },
  methods: {
    onSubmit() {
      this.$v.form.$touch();

      if (this.$v.form.$anyError) return;

      this.loading = true;

      authService
        .changePassword(this.form)
        .then(() => {
          this.$notify({
            type: 'success',
            duration: 4000,
            text: 'Changed successfully! ပြောင်းလဲပြီးပါပြီ။',
          });

          this.responseMessage = '';
          this.loading = false;
          this.resetForm();

          localStorage.removeItem("passwordExpired");

           this.$router.push({ name: "Home" });

        })
        .catch((error) => {
          console.error(error, error.response.data);
          this.responseMessage = error.response.data.message;

          let duration = 8000;
          let text =
            'Something went wrong. Try again. တစ်ခုခုမှားယွင်းသွားခဲ့ပါတယ်။ ပြန်လည်ကြိုးစားကြည့်ပါ။';

          if (
            this.responseMessage &&
            !this.responseMessage.includes('SQL [n/a];')
          ) {
            duration = 3000;
            text = this.responseMessage;
          }

          if (this.responseMessage.includes('SQL [n/a];'))
            this.responseMessage = text;

          if (this.responseMessage == 'Incorrect password.') {
            text = 'Incorrect old password.';
            this.responseMessage = 'Incorrect old password.';
          }

          this.loading = false;
          this.$notify({
            type: 'error',
            duration,
            text,
          });
        });
    },
    resetForm() {
      this.form = {
        oldPassword: null,
        newPassword: null,
        confirmPassword: null,
      };

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    mustChangePassword() {
      const user = this.$store.state.auth.user;
      if (!user || !user.updatedDateInMilliSeconds) return true;
      const lastChange = new Date(user.updatedDateInMilliSeconds);
      const now = new Date();
      return now - lastChange >= 365 * 24 * 60 * 60 * 1000;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
  },
};
</script>
<style scoped>
.Login {
  color: blue;
}
</style>
